import { createStore, type Store } from "@quotientjs/browser-storage"
import { z } from "zod"

export const BROWSER_FINGERPRINT_STORAGE_KEY = "quotient-browser-fingerprint"

// Browser fingerprint is a hash string (now could be SHA-256 or FNV-1a)
export type BrowserFingerprint = string

export const BrowserFingerprintStore: Store<BrowserFingerprint, "local"> =
  createStore({
    key: BROWSER_FINGERPRINT_STORAGE_KEY,
    validator: z.string(),
    storageType: "local",
  })
